import { months } from './DrawerEmployees.constants';
import { OrderType } from './DrawerEmployees.types';

export const formatDate = (date?: string) => {
	if (!date) return '';

	const [year, month, day] = date.split('-');
	return `${parseInt(day)} / ${months[parseInt(month) - 1]} / ${year}`;
};

export const getAmountReceivedResults = (orders?: OrderType[]) => {
	return (
		orders
			?.map((order) => order?.externalOrders ?? [])
			.flat()
			.filter((externalOrder) => externalOrder?.status === 'finished').length ||
		0
	);
};

export const getAmountAllResults = (orders?: OrderType[]) => {
	return (
		orders?.reduce(
			(acc, order) =>
				acc + (order?.externalOrders ? order.externalOrders.length : 0),
			0,
		) || 0
	);
};

export const renderDate = (initialDate?: string, finalDate?: string) => {
	if (!initialDate) return '';
	if (!finalDate || finalDate === initialDate) return formatDate(initialDate);

	return `${formatDate(initialDate)} - ${formatDate(finalDate)}`;
};
